import { Device } from "../Device";

export class ScrollView extends PIXI.Container {
    static DECAY: number = 0.97;
    static BOUNCING_DECAY: number = 0.8;
    static SPEED_SPRINGNESS: number = 0.8;
    static BOUNCING_SPRINGESS: number = 0.15;
    static DRAG_DECAY: number = 0.4;

    private _contentView: PIXI.Container;
    private _maskSize: PIXI.Point;
    private _touchDown: boolean;
    private _posY: number = 0;
    private _lastPosY: number = 0;
    private _startPosY: number = 0;
    private _startTouchPosY: number = 0;
    private _scrollSpeed: number = 0;
    private _stopAnimation: boolean;

    constructor() {
        super();

        this.createMask(0, 0);

        this.on(Device.resolveEvent("mousedown"), this.onMouseDown, this);
        this.on(Device.resolveEvent("mousemove"), this.onMouseMove, this);
        this.on(Device.resolveEvent("mouseup"), this.onMouseUp, this);
        this.interactive = true;

        PIXI.ticker.shared.add(this.animateScroll, this);
    }

    set contentView(view: PIXI.Container) {
        if (this._contentView != view) {
            if (this._contentView != null)
                this.removeChild(this._contentView);

            this._contentView = view;

            if (this._contentView != null)
                this.addChild(this._contentView);
        }
    }

    get contentView(): PIXI.Container {
        return this._contentView;
    }

    setSize(width: number, height: number) {
        this.createMask(width, height);
    }

    dispose() {
        this._stopAnimation = true;

        this.off(Device.resolveEvent("mousedown"), this.onMouseDown, this);
        this.off(Device.resolveEvent("mousemove"), this.onMouseMove, this);
        this.off(Device.resolveEvent("mouseup"), this.onMouseUp, this);

        PIXI.ticker.shared.remove(this.animateScroll, this);
    }

    private createMask(width: number, height: number) {
        if (this._maskSize == null)
            this._maskSize = new PIXI.Point();

        this._maskSize.set(width, height);

        var mask: PIXI.Graphics;
        if (this.mask instanceof PIXI.Graphics)
            mask = this.mask as PIXI.Graphics;
        else
            mask = new PIXI.Graphics();

        mask.clear();
        mask.beginFill(0xff0000);
        mask.drawRect(0, 0, width, height);
        mask.endFill();

        this.mask = mask;
    }

    private animateScroll() {
        if (this._stopAnimation)
            return;

        if (!this._touchDown && this._contentView) {
            this._scrollSpeed *= ScrollView.DECAY;

            var bouncing = 0;
            var y = this._posY;

            // calculate a bouncing when the text moves over the canvas size
            if (y > 0) {
                bouncing = -y * ScrollView.BOUNCING_SPRINGESS;
                this._scrollSpeed *= ScrollView.BOUNCING_DECAY;
            }
            else if (y + this._contentView.height < this._maskSize.y) {
                bouncing = (this._maskSize.y - this._contentView.height - y) *
                    ScrollView.BOUNCING_SPRINGESS;
                this._scrollSpeed *= ScrollView.BOUNCING_DECAY;
            }

            this._posY = y + this._scrollSpeed + bouncing;
            this._contentView.position.set(0, this._posY);
        }
    }

    private onMouseDown(event: any) {
        if (!this._contentView || this._contentView.height <= this._maskSize.y)
            return;

        this._scrollSpeed = 0;
        this._touchDown = true;

        const coords: PIXI.Point = event.data.getLocalPosition(this);
        this._lastPosY = coords.y;
        this._startPosY = this._posY;
        this._startTouchPosY = coords.y;
    }

    private onMouseMove(event: any) {
        if (this._touchDown) {

            const coords: PIXI.Point = event.data.getLocalPosition(this);

            var decay = 1;
            const y = this._startPosY + (coords.y - this._startTouchPosY);
            if (y > 0 || y + this._contentView.height < this._maskSize.y)
                decay = ScrollView.DRAG_DECAY;

            this._posY = this._posY + (coords.y - this._lastPosY) * decay;

            this._scrollSpeed = ((coords.y - this._lastPosY) * ScrollView.SPEED_SPRINGNESS);

            this._lastPosY = coords.y;

            this._contentView.position.set(0, this._posY);
        }
    }

    private onMouseUp(event: any) {
        this._touchDown = false;
    }
}
